import { releaseProxy } from 'comlink'
import { endpointSymbol } from 'vite-plugin-comlink/symbol'

export interface ComlinkWorkerInstanceType {
	readonly [endpointSymbol]: Worker
}

export function destroyWorker(worker: ComlinkWorkerInstanceType) {
	if (!worker) return

	// https://github.com/mathe42/vite-plugin-comlink/pull/138
	worker[endpointSymbol].terminate()
	worker[releaseProxy]() // fly to GC land, little proxy!
}

// Singleton sync worker - created on first use, reused thereafter
let cachedSyncWorker: InstanceType<typeof ComlinkWorker<typeof import('./sync-worker.ts')>> | null = null

export function getSyncWorker() {
	if (!cachedSyncWorker) {
		// (i) The `{ type: 'module' }` below MUST stay. vite.config sets `worker.format: 'es'`
		// and the minified worker chunk is emitted as a real ES module (`export default …`).
		// Without it, vite-plugin-comlink emits `new Worker(url, {})` = a CLASSIC worker,
		// which dies on parse with "Unexpected token 'export'": the worker never starts and
		// all sync silently stops (visible only as a `window.error` banner with no message).
		// NB: the plugin parses this options object with JSON5 — keep it a single-line
		// literal, no comments inside the parens, or the build fails with "invalid end of input".
		cachedSyncWorker = new ComlinkWorker<typeof import('./sync-worker.ts')>(
			new URL('./sync-worker.ts', import.meta.url),
			{ type: 'module' },
		)
	}
	return cachedSyncWorker
}
